export enum ENavigationListKeys {
  "Ecosystem" = "Ecosystem",
  "Community" = "Community",
  "HapiId" = "HapiId",
  "About" = "About",
  "Docs" = "Docs",
  "BuyCrypto" = "BuyCrypto",
  "Tools" = "Tools",
}
